import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/internal/Subscription';

import { Teacher } from '@app/definitions/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { AccountService } from '@app/teacher/services/account.service';

@Component({
    selector: 'app-prepare-subject-list',
    templateUrl: './prepare-subject-list.component.html',
    styleUrls: ['./prepare-subject-list.component.scss']
})
export class PrepareSubjectListComponent implements OnInit, OnDestroy {
    teacher: Teacher;
    subjectId: number;
    classId: number;
    private routeDataSubscription: Subscription;
    private routeParamsSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private teacherService: TeacherService,
        private accountService: AccountService
    ) {}

    public ngOnInit(): void {
        this.routeDataSubscription = this.accountService.$currentTeacher.subscribe((teacher: Teacher) => {
            this.teacher = teacher;
        });
        this.routeParamsSubscription = this.route.parent.params.subscribe(params => {
            this.subjectId = +params['subject_id'];
            this.classId = +params['class_id'];
            this.teacherService.setClassId(+params['class_id']);
            this.teacherService.setSubjectId(+params['subject_id']);
        });
    }

    public ngOnDestroy(): void {
        this.routeDataSubscription.unsubscribe();
        this.routeParamsSubscription.unsubscribe();
    }
}
